export const getApiVersion = state => {
  const app = state.app || state;
  return app.apiVersion;
};
